var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIncomeCalendar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 25,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 24.91h22.96V0H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 22.52c0 .79-.64 1.43-1.43 1.43H2.39c-.79 0-1.43-.64-1.43-1.43V4.34c0-.79.64-1.43 1.43-1.43h18.18c.79 0 1.43.64 1.43 1.43v18.18zM20.57 1.95H2.39A2.39 2.39 0 0 0 0 4.34v18.18a2.39 2.39 0 0 0 2.39 2.39h18.18a2.39 2.39 0 0 0 2.39-2.39V4.34a2.39 2.39 0 0 0-2.39-2.39z",
  fill: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 4.34V7H.96V4.34c0-.79.64-1.43 1.43-1.43h18.18c.79 0 1.43.64 1.43 1.43",
  fill: "#EEE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.91 7.43c0 .24-.19.43-.43.43h-22c-.24 0-.43-.19-.43-.43S.24 7 .48 7h22c.24 0 .43.19.43.43",
  fill: "#252525"
}), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M4.91 4h1.14V.86H4.91V4zM6.78.13a.434.434 0 0 0-.3-.13h-2c-.11 0-.22.05-.3.13-.08.08-.13.19-.13.3v4c0 .11.05.22.13.3.08.08.19.13.3.13h2c.11 0 .22-.05.3-.13.08-.08.13-.19.13-.3v-4c0-.11-.05-.22-.13-.3z",
  fill: "#252525",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  mask: "url(#b)",
  d: "M4.91 4h1.14V.86H4.91z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.91 4h1.14V.86h-1.14V4zM18.78.13a.434.434 0 0 0-.3-.13h-2c-.11 0-.22.05-.3.13-.08.08-.13.19-.13.3v4c0 .11.05.22.13.3.08.08.19.13.3.13h2c.11 0 .22-.05.3-.13.08-.08.13-.19.13-.3v-4c0-.11-.05-.22-.13-.3z",
  fill: "#252525",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  mask: "url(#b)",
  d: "M16.91 4h1.14V.86h-1.14z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIncomeCalendar);
export default ForwardRef;